var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classnames from "classnames";
import { viewInRoomCls, viewInRoomCoverCls, viewInRoomWrapperCls, viewInRoomScaledCls, viewInRoomHiddenCls, viewInRoomBkgWrapperCls, viewInRoomArtWrapperCls, viewInRoomArtWrapperNoImageCls } from "./ViewInRoom.less";
var ViewInRoomPreview = /* @__PURE__ */ function(_Component) {
  function ViewInRoomPreview2(props) {
    var _this;
    _classCallCheck(this, ViewInRoomPreview2);
    _this = _callSuper(this, ViewInRoomPreview2, [props]);
    _this.wrapperRef = /* @__PURE__ */ React.createRef();
    _this.state = {
      isVisible: false,
      viewWidth: 0,
      viewHeight: 0,
      viewStyles: null,
      imageStyle: null,
      correctedImagePosition: {}
    };
    _this.bindMethods();
    return _this;
  }
  __name(ViewInRoomPreview2, "ViewInRoomPreview");
  _inherits(ViewInRoomPreview2, _Component);
  return _createClass(ViewInRoomPreview2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      if (!this.state.viewWidth) {
        this.handleBackgroundLoad();
      }
    }, "componentDidMount")
    /**
     * handleBackgroundLoad
     *
     * @returns {void}
     */
  }, {
    key: "handleBackgroundLoad",
    value: /* @__PURE__ */ __name(function handleBackgroundLoad() {
      if (!this.wrapperRef || !this.wrapperRef.current) {
        return;
      }
      var _this$props = this.props, config = _this$props.config, scaled = _this$props.scaled, calcByWidth = _this$props.calcByWidth, isCover = _this$props.isCover;
      var wrapperDimensions = this.wrapperRef.current.getBoundingClientRect();
      var wrapperHeight = wrapperDimensions.height, wrapperWidth = wrapperDimensions.width;
      var dimensions = {
        width: !calcByWidth ? wrapperHeight / config.background.height * config.background.width : wrapperWidth,
        height: wrapperWidth / config.background.width * config.background.height
      };
      if (isCover) {
        var coverByWidth = wrapperWidth / dimensions.width > wrapperHeight / dimensions.height;
        dimensions.width = coverByWidth ? wrapperWidth : wrapperHeight / config.background.height * config.background.width;
        dimensions.height = coverByWidth ? wrapperWidth / config.background.width * config.background.height : wrapperHeight;
      } else if (dimensions.width > wrapperWidth) {
        dimensions.width = wrapperWidth;
        dimensions.height = wrapperWidth / config.background.width * config.background.height;
      } else if (!calcByWidth && dimensions.height > wrapperHeight) {
        dimensions.height = wrapperHeight;
        dimensions.width = wrapperHeight / config.background.height * config.background.width;
      }
      var scaleIndex = dimensions.height / (scaled && config.scale ? config.scale.background.height : config.background.height);
      var imageStyle = this.calculateImageStyles(scaleIndex);
      var scaledImageTopCorrection = null;
      if (scaled) {
        if (imageStyle.top + imageStyle.height / 2 > dimensions.height / 2) {
          scaledImageTopCorrection = dimensions.height / 2;
        }
        var artworkBottomPosition = imageStyle.height / 2 + imageStyle.top;
        var maxAllowedPosition = (config.scale.artwork.y + config.scale.artwork.height.max / config.pixelsPerCentimeter / 2) * scaleIndex;
        if (artworkBottomPosition > maxAllowedPosition) {
          imageStyle.top -= artworkBottomPosition - maxAllowedPosition;
        }
      }
      var correctedImagePosition = isCover ? ViewInRoomPreview2.centerArtwork(wrapperDimensions, config, scaleIndex) : {};
      this.setState({
        isVisible: true,
        viewWidth: scaled ? config.background.width * scaleIndex : dimensions.width,
        viewHeight: scaled ? config.background.height * scaleIndex : dimensions.height,
        viewStyles: scaled && scaledImageTopCorrection ? {
          top: "".concat(-(imageStyle.top - scaledImageTopCorrection), "px")
        } : null,
        imageStyle: {
          width: "".concat(imageStyle.width, "px"),
          height: "".concat(imageStyle.height, "px"),
          top: "".concat(scaled && scaledImageTopCorrection ? scaledImageTopCorrection : imageStyle.top, "px"),
          left: "".concat(imageStyle.left, "px")
        },
        correctedImagePosition: _objectSpread(_objectSpread({}, dimensions.height > wrapperHeight ? {
          top: correctedImagePosition.top
        } : null), dimensions.width > wrapperWidth ? {
          left: correctedImagePosition.left
        } : null)
      });
    }, "handleBackgroundLoad")
    /**
     * calculateImageStyles
     *
     * @returns {Object} styles
     */
  }, {
    key: "calculateImageStyles",
    value: /* @__PURE__ */ __name(function calculateImageStyles(scaleIndex) {
      var _this$props2 = this.props, width = _this$props2.width, height = _this$props2.height, config = _this$props2.config, scaled = _this$props2.scaled;
      return {
        width: width * config.pixelsPerCentimeter * scaleIndex,
        height: height * config.pixelsPerCentimeter * scaleIndex,
        top: (scaled ? config.scale.artwork.y : config.artwork.y) * scaleIndex,
        left: (scaled ? config.scale.artwork.x : config.artwork.x) * scaleIndex
      };
    }, "calculateImageStyles")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleBackgroundLoad = this.handleBackgroundLoad.bind(this);
    }, "bindMethods")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props3 = this.props, config = _this$props3.config, className = _this$props3.className, scaled = _this$props3.scaled, backgroundPicture = _this$props3.backgroundPicture, children = _this$props3.children, isCover = _this$props3.isCover;
      var _this$state = this.state, isVisible = _this$state.isVisible, correctedImagePosition = _this$state.correctedImagePosition, viewWidth = _this$state.viewWidth, viewHeight = _this$state.viewHeight, viewStyles = _this$state.viewStyles, imageStyle = _this$state.imageStyle;
      return /* @__PURE__ */ React.createElement("div", {
        className: classnames(viewInRoomCls, _defineProperty(_defineProperty(_defineProperty({}, viewInRoomScaledCls, scaled), viewInRoomHiddenCls, !isVisible), viewInRoomCoverCls, isCover), className)
      }, /* @__PURE__ */ React.createElement("div", _extends({
        className: viewInRoomWrapperCls
      }, isVisible ? {
        style: _objectSpread({
          width: viewWidth,
          height: viewHeight
        }, correctedImagePosition)
      } : null), /* @__PURE__ */ React.createElement("div", _extends({
        className: viewInRoomBkgWrapperCls,
        ref: this.wrapperRef
      }, scaled && viewStyles ? {
        style: viewStyles
      } : null), typeof backgroundPicture === "function" ? backgroundPicture({
        config,
        imgProps: _objectSpread({}, isVisible ? {
          style: {
            width: viewWidth
          }
        } : null)
      }) : null), /* @__PURE__ */ React.createElement("div", {
        className: classnames(viewInRoomArtWrapperCls, _defineProperty({}, viewInRoomArtWrapperNoImageCls, !children)),
        style: isVisible ? imageStyle : null
      }, children)));
    }, "render")
  }], [{
    key: "centerArtwork",
    value: (
      /**
       * centerArtwork
       *
       * @param {Object} wrapper
       * @param {Object} config
       * @param {number} scaleIndex
       * @returns {Object}
       */
      /* @__PURE__ */ __name(function centerArtwork(wrapper, config, scaleIndex) {
        var newImageProps = {
          top: 0,
          left: 0
        };
        var cropArea = config.cropArea, background = config.background;
        var cropX = (cropArea.x + cropArea.width / 2) * scaleIndex;
        var cropY = (cropArea.y + cropArea.height / 2) * scaleIndex;
        if (cropX > wrapper.width / 2) {
          var bkgWidth = background.width * scaleIndex;
          newImageProps.left = wrapper.width / 2 - cropArea.x * scaleIndex;
          if (bkgWidth + newImageProps.left < wrapper.width) {
            newImageProps.left = wrapper.width - bkgWidth;
          }
        }
        if (cropY > wrapper.height / 2) {
          newImageProps.top = wrapper.height / 2 - cropArea.y * scaleIndex;
        }
        if (newImageProps.top > 0) {
          newImageProps.top = 0;
        }
        if (newImageProps.left > 0) {
          newImageProps.left = 0;
        }
        return newImageProps;
      }, "centerArtwork")
    )
  }]);
}(Component);
_defineProperty(ViewInRoomPreview, "defaultProps", {
  className: null,
  children: null,
  scaled: false,
  backgroundPicture: null,
  calcByWidth: false,
  isCover: false
});
export {
  ViewInRoomPreview
};
